import type { App } from 'vue'

const zoomableElements = new WeakSet<HTMLElement>()
let zoomPromise: Promise<ReturnType<typeof import('medium-zoom')['default']>> | undefined

function getZoom() {
  zoomPromise ??= import('medium-zoom').then(({ default: mediumZoom }) => {
    return mediumZoom({
      background: 'var(--g-main-area-bg)',
      margin: 20,
    })
  })
  return zoomPromise
}

export default function directive(app: App) {
  app.directive('zoomable', {
    mounted(el: HTMLElement) {
      zoomableElements.add(el)
      void getZoom().then((zoom) => {
        if (zoomableElements.has(el)) {
          zoom.attach(el)
        }
      })
    },
    unmounted(el: HTMLElement) {
      zoomableElements.delete(el)
      void zoomPromise?.then(zoom => zoom.detach(el))
    },
  })
}
